import { createContext } from 'react'
import type { Session } from '@supabase/supabase-js'

export interface AuthContextValue {
  session: Session | null
  /** True while the initial session is being restored. */
  loading: boolean
  signIn: (email: string, password: string) => Promise<{ error: string | null }>
  /**
   * Passwordless sign-in: e-mail a Supabase magic link (`signInWithOtp`).
   *
   * `redirectPath` is the in-app path to land on after the link is followed
   * (e.g. `/founder/forms/123`); it is passed as the OTP `emailRedirectTo` so a
   * single click in the inbox opens that page already authenticated. Founders
   * are emailed this exact flow when a form is sent (spec-17 D18).
   */
  signInWithMagicLink: (
    email: string,
    redirectPath?: string,
  ) => Promise<{ error: string | null }>
  signOut: () => Promise<void>
}

export const AuthContext = createContext<AuthContextValue | null>(null)
